import type { ReactNode } from 'react';

export default function NoteCallout({ children }: { children: ReactNode }) {
  return (
    <div className="flex gap-2.5 items-start bg-note-bg border border-note-border rounded-md px-3.5 py-3 mb-2.5">
      <span className="font-serif font-semibold text-[13px] text-olive tracking-[0.06em] uppercase shrink-0">Note</span>
      <span className="text-sm text-muted leading-relaxed">{children}</span>
    </div>
  );
}
